import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, Stack } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const DEFAULT_MENU_SKELETON_HEIGHT = 32;
const DEFAULT_AVATAR_HEIGHT = 20;
const DEFAULT_CONTENT_HEIGHT = 12;
const DEFAULT_BORDER_RADIUS = 4;

type MenuSkeletonItemProps = {
	avatarHeight?: number;
	contentHeight?: number;
	skeletonHeight?: number;
};

const styles = cssMap({
	root: {
		height: `${DEFAULT_MENU_SKELETON_HEIGHT}px`,
		width: '100%',
		paddingTop: token('space.0'),
		paddingBottom: token('space.0'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	avatar: {
		paddingLeft: token('space.025'),
	},
});

export const MenuSkeletonItem = ({
	avatarHeight = DEFAULT_AVATAR_HEIGHT,
	contentHeight = DEFAULT_CONTENT_HEIGHT,
}: MenuSkeletonItemProps) => {
	return (
		<Stack xcss={cx(styles.root)} alignBlock="center">
			<Flex alignItems="center" gap="space.050">
				<Box xcss={cx(styles.avatar)}>
					<Skeleton
						width={avatarHeight}
						height={avatarHeight}
						borderRadius={DEFAULT_BORDER_RADIUS}
					/>
				</Box>
				<Skeleton width="100%" height={contentHeight} borderRadius="0" />
			</Flex>
		</Stack>
	);
};
